import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, Suspense as _Suspense, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { style: {"text-align":"center"} }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { style: {"margin-bottom":"8px"} }, "未知的 cls 参数，当前支持的应用如下：", -1 /* HOISTED */)
const _hoisted_3 = { style: {"display":"inline-block","text-align":"left","margin":"0 auto","padding-left":"20px","line-height":"1.8"} }
const _hoisted_4 = { style: {"text-align":"center"} }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { style: {"margin-bottom":"8px"} }, "请指定 cls 参数，支持的应用如下：", -1 /* HOISTED */)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { style: {"margin-top":"12px","margin-bottom":"4px"} }, "支持的应用：", -1 /* HOISTED */)
const _hoisted_7 = { style: {"display":"inline-block","text-align":"left","margin":"0 auto","padding-left":"20px","line-height":"1.8"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_a_empty = _resolveComponent("a-empty")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_a_config_provider = _resolveComponent("a-config-provider")!

  return (_openBlock(), _createBlock(_component_a_config_provider, { locale: $setup.locale }, {
    default: _withCtx(() => [
      ($setup.isIndexHtmlRoute)
        ? (_openBlock(), _createBlock($setup["layout"], { key: 0 }, {
            default: _withCtx(() => [
              ($setup.currentClsComponent)
                ? (_openBlock(), _createBlock(_Suspense, { key: 0 }, {
                    fallback: _withCtx(() => [
                      _createVNode(_component_a_spin, {
                        size: "large",
                        style: {"display":"flex","justify-content":"center","padding":"48px"}
                      })
                    ]),
                    default: _withCtx(() => [
                      (_openBlock(), _createBlock(_resolveDynamicComponent($setup.currentClsComponent)))
                    ]),
                    _: 1 /* STABLE */
                  }))
                : ($setup.route.query.cls)
                  ? (_openBlock(), _createBlock(_component_a_empty, { key: 1 }, {
                      description: _withCtx(() => [
                        _createElementVNode("div", _hoisted_1, [
                          _hoisted_2,
                          _createElementVNode("ul", _hoisted_3, [
                            (_openBlock(), _createElementBlock(_Fragment, null, _renderList($setup.supportedClsApps, (app) => {
                              return _createElementVNode("li", {
                                key: app.cls
                              }, [
                                _createElementVNode("code", null, "index.html?cls=" + _toDisplayString(app.cls), 1 /* TEXT */),
                                _createTextVNode(" — " + _toDisplayString(app.name), 1 /* TEXT */)
                              ])
                            }), 64 /* STABLE_FRAGMENT */))
                          ])
                        ])
                      ]),
                      _: 1 /* STABLE */
                    }))
                  : (_openBlock(), _createBlock(_component_a_empty, { key: 2 }, {
                      description: _withCtx(() => [
                        _createElementVNode("div", _hoisted_4, [
                          _hoisted_5,
                          _hoisted_6,
                          _createElementVNode("ul", _hoisted_7, [
                            (_openBlock(), _createElementBlock(_Fragment, null, _renderList($setup.supportedClsApps, (app) => {
                              return _createElementVNode("li", {
                                key: app.cls
                              }, [
                                _createElementVNode("code", null, "index.html?cls=" + _toDisplayString(app.cls), 1 /* TEXT */),
                                _createTextVNode(" — " + _toDisplayString(app.name), 1 /* TEXT */)
                              ])
                            }), 64 /* STABLE_FRAGMENT */))
                          ])
                        ])
                      ]),
                      _: 1 /* STABLE */
                    }))
            ]),
            _: 1 /* STABLE */
          }))
        : (_openBlock(), _createBlock(_component_router_view, { key: 1 }))
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["locale"]))
}